import React, { useContext } from 'react';
import propTypes from 'prop-types';
import { BsCartPlusFill } from 'react-icons/bs';

import './ProductCard.css';
import formatCurrency from '../../utils/formatCurrency';
import AppContext from '../../context/AppContext';

function ProductCard({ data }) {
	const { cartItems, setCartItems } = useContext(AppContext);
	const handleAddCart = () => setCartItems([ ...cartItems, data ]); 


	const { price, thumbnail, title } = data;
	return(
		<section className="product-card">
			<img src= {thumbnail.replace(/\w\.jpg/gi, 'W.jpg')} alt="product" className="card__image"/>
			<div className="card__infos">
				<h2 className="card__price">{formatCurrency(price)}</h2>
				<h2 className="card__title">{title} </h2>
			</div>
			<button type="button" onClick={ handleAddCart } className="button__add-cart"><BsCartPlusFill /></button>
		</section>
	);
}

export default ProductCard;

ProductCard.propTypes = {
	data: propTypes.shape({})
}.isRequired;
